import { Link, useParams } from 'react-router-dom';
import { LeadDetailContent } from './LeadDetailContent';

export function LeadDetailPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;

  return (
    <div style={{ display: 'grid', gap: 'var(--space-4)', maxWidth: 640 }}>
      <LeadDetailContent id={id} />
      <p style={{ margin: 0, fontSize: 'var(--font-size-sm)' }}>
        <Link to="/leads">← All leads</Link>
      </p>
    </div>
  );
}
